import React, { useState, useEffect } from "react";
import api from "../api";
import { MessageSquare, Calendar, User, AlignLeft } from "lucide-react";
import toast from "react-hot-toast";

export default function FeedbackPage() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      const res = await api.get("/feedback");
      setFeedbacks(res.data || []);
    } catch (err) {
      toast.error("Không thể tải danh sách góp ý");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6" style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}>
      {/* Header */}
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-blue-900 to-teal-600">
          Góp Ý Người Dùng
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Xem xét các ý kiến đóng góp và báo lỗi từ người dùng hệ thống.
        </p>
      </div>

        {/* Content */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 rounded-full border-4 border-teal-500 border-t-transparent animate-spin"/>
          </div>
        ) : feedbacks.length === 0 ? (
          <div className="bg-white rounded-2xl border border-gray-200 p-16 text-center shadow-sm">
            <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100">
              <MessageSquare className="w-8 h-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Chưa có góp ý nào</h3>
            <p className="text-gray-500 mt-2">Hệ thống gửi góp ý hiện đang trống.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {feedbacks.map((fb) => (
              <div key={fb.id} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden group">
                <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-blue-500 to-teal-400 group-hover:w-1.5 transition-all" />
                
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${
                    fb.status === 'new' ? 'bg-blue-50 text-blue-700' : 'bg-gray-100 text-gray-600'
                  }`}>
                    {fb.status === 'new' ? 'MỚI' : 'ĐÃ XEM'}
                  </span>
                  <div className="flex items-center text-xs text-gray-400">
                    <Calendar className="w-3.5 h-3.5 mr-1" />
                    {new Date(fb.created_at).toLocaleDateString('vi-VN')}
                  </div>
                </div>

                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-8 h-8 rounded-full bg-teal-50 flex items-center justify-center text-teal-700 font-bold border border-teal-100">
                    {(fb.user_email || "?")[0].toUpperCase()}
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900">{fb.user_email || "Anonymous"}</h4>
                    <p className="text-xs text-gray-400">Người dùng hệ thống</p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 relative">
                  <AlignLeft className="w-4 h-4 text-gray-300 absolute top-4 left-4" />
                  <p className="pl-6 text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
                    {fb.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
  );
}
